var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPagerDuty(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0392 35.1687V47.9324H7V35.1687H14.0392ZM21.0705 9.99732e-05C27.1021 0.0067434 29.7164 0.348948 33.4313 2.35553C37.5124 4.54673 40.0323 8.90173 40.0323 14.3249C40.0323 19.3647 37.978 23.7197 34.0339 26.3217C30.4184 28.732 26.3099 29.0607 20.8319 29.0607H7V0L21.0705 9.99732e-05ZM21.9823 6.16273L14.0392 6.21751V22.9802H22.4479C28.3368 22.9802 32.8287 20.6246 32.8287 14.4071C32.8287 8.62783 29.2132 6.10795 21.9823 6.16273Z",
    fill: "#06AC38"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPagerDuty);
export default __webpack_public_path__ + "static/media/Pager_duty.02a53fc7605350a1b6490dfdeb633944.svg";
export { ForwardRef as ReactComponent };